import React, { useState } from "react";
import Modal from "components/UI/DialogModal";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Autocomplete,
} from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { ITopic } from "models/topic";
import { ICompanyTopicInput } from "models/companyTopics";
import { ICompetency } from "models/competency";
import { ICompanyCompetency, ICompanyCompetencyInput } from "models/companyCompetencies";
import { useAlert } from "contexts/alertContext";



interface Props {
  open: boolean;
  loading: boolean;
  competencies: ICompetency[];
  companyCompetencies:ICompanyCompetency[];
  onClose: () => void;
  onSubmit: (data: ICompanyCompetencyInput[]) => void;
}





const AddCompanyCompetency: React.FC<Props> = ({
  open,
  loading,
  competencies,
  companyCompetencies,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const [title, setTitle] = useState<string>("");
  const [titleAr, setTitleAr] = useState<string>("");
  const [entries, setEntries] = useState<ICompanyCompetencyInput[]>([]);
  const { setAlert } = useAlert();
  const competenciesEnglishOptions = competencies.map((comp) => ({
    value: comp.id,
    label: comp.name,
  }));

  const competenciesArabicOptions = competencies.map((comp) => ({
    value: comp.id,
    label: comp.nameAr,
  }));

  const handleTitleChange = (newValue: string | null) => {
    setTitle(newValue || "");

    const selectedTopic = competencies.find((comp) => comp.name === newValue);
    if (selectedTopic) {
      setTitleAr(selectedTopic.nameAr);

    } else {
      setTitleAr("");

    }
  };

  const combinationExisted = (topicAr: string, topicEn: string) => {

    const existingEntry = companyCompetencies?.find((entry) => entry?.name === topicEn && entry?.nameAr === topicAr);
    return existingEntry ? true : false;
  }

  const handleTitleArChange = (newValue: string | null) => {
    setTitleAr(newValue || "");

    const selectedTopic = competencies.find((comp) => comp.nameAr === newValue);
    if (selectedTopic) {
      setTitle(selectedTopic.name);

    } else {
      setTitle("");
  
    }
  };

  const addEntry = () => {
    if (title || titleAr) {

      const existingEntry = entries.some(
        (entry) => entry.name === title && entry.nameAr === titleAr
      );
      
      if ( 
        existingEntry ||
        combinationExisted(titleAr, title)
      ) {
        setAlert({
          open: true,
          message: "Competency Already Exists",
          type: "info",
        });
        return;
      }

      setEntries([
        ...entries,
        {
    
          name:  title,
          nameAr:  titleAr,
        },
      ]);
      setTitle("");
      setTitleAr("");
   
    }
  };

  const removeEntry = (index: number) => {
    setEntries(entries.filter((_, i) => i !== index));
  };




  const clearFields = () => {
    setTitle("");
    setTitleAr("");
  
  };


  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_add_competency")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                {/* <Autocomplete
                  freeSolo
                  options={competenciesEnglishOptions.map((option) => option.label)}
                  style={{minWidth:'300px'}}
                  value={title}
           
                  onChange={(event, newValue) => handleTitleChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title")}
                      variant="outlined"
                      onChange={(e) => setTitle(e.target.value)}
                   
                    />
                  )}
                /> */}
                <TextField
                      value={title}
                      label={t("T_title")}
                      variant="outlined"
                      onChange={(e) => setTitle(e.target.value)}
                   
                    />

                {/* <Autocomplete
                  freeSolo
                  options={competenciesArabicOptions.map((option) => option?.label || '')}
                  style={{minWidth:'300px'}}
                  value={titleAr}
               
                  onChange={(event, newValue) => handleTitleArChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title_Ar")}
                      variant="outlined"
                      onChange={(e) => setTitleAr(e.target.value||'')}
                  
                    />
                  )}
                /> */}

                    <TextField
                      label={t("T_title_Ar")}
                      value={titleAr}
                      variant="outlined"
                      onChange={(e) => setTitleAr(e.target.value||'')}
                  
                    />

                <Button
                  variant="contained"
                  style={{ borderRadius: 0 }}
                  onClick={addEntry}
                  disabled={
                    !title || !titleAr
                  }
                >
                  {t("T_add")}
                </Button>

                <Button
                  variant="outlined"
                  style={{ borderRadius: 0 }}
                  onClick={clearFields}
                >
                  {t("T_clear")}
                </Button>

              </div>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t("T_title")}</TableCell>
                    <TableCell>{t("T_title_Ar")}</TableCell>
                    <TableCell>{t("T_action")}</TableCell>
                  </TableRow>
                </TableHead>
              <TableBody>
                  {entries.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {entry.name}
                      </TableCell>
                      <TableCell>
                         {entry.nameAr}
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => removeEntry(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={() => onSubmit(entries)}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default AddCompanyCompetency;
